const disallowedSpecialChars = /[<>"'\\;]+|--/;

export default function validateInput(userInput) {
    if (disallowedSpecialChars.test(userInput)) return false;

    const sqlInjectionPattern = /(\b(SELECT|INSERT|UPDATE|DELETE|DROP|TRUNCATE|ALTER|CREATE|EXEC|UNION)\b)|(['"=;])|(--)/i;
    const codeInjectionPattern = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/i;
    if (sqlInjectionPattern.test(userInput) || codeInjectionPattern.test(userInput)) return false;

    return true;
}
